export default "__VITE_ASSET__5aa00409__"